import { call, put, takeLatest } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import * as types from './actionTypes';
import { post } from '../../../helpers/api_helper';

function* fetchResourceApprovalSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_RESOURCE_APPROVAL, payload);

    if (response.status !== 'success') throw new Error(response.message || 'Fetch failed');

    yield put({ type: types.FETCH_RESOURCE_APPROVAL_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_RESOURCE_APPROVAL_FAILURE, payload: error });
  }
}

function* updateResourceApprovalSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_UPDATE_RESOURCE_APPROVAL, payload);

    if (response.status !== 'success') throw new Error(response.message || 'Update failed');

    Swal.fire('Success', response.message || 'Updated successfully', 'success');
    yield put({ type: types.UPDATE_RESOURCE_APPROVAL_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.UPDATE_RESOURCE_APPROVAL_FAILURE, payload: error });
  }
}

function* fetchJobDetailsApprovalSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_JOBDETAILS_APPROVAL, payload);

    if (response.status !== 'success') throw new Error(response.message || 'Fetch failed');

    yield put({ type: types.FETCH_JOBDETAILS_APPROVAL_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_JOBDETAILS_APPROVAL_FAILURE, payload: error });
  }
}

export default function* resourceApprovalSaga() {
  yield takeLatest(types.FETCH_RESOURCE_APPROVAL_REQUEST, fetchResourceApprovalSaga);
  yield takeLatest(types.UPDATE_RESOURCE_APPROVAL_REQUEST, updateResourceApprovalSaga);
  yield takeLatest(types.FETCH_JOBDETAILS_APPROVAL_REQUEST, fetchJobDetailsApprovalSaga);
}
